<template>

  <div>
    <div class="hit-form-group">
      <label class="hit-html-label">{{ $t("message.terms") }}</label>

      {{ $t("terms.termsAccept") }}
    </div>
    <div class="hit-form-group">

      <hit_toggle :data="get_toggle()" :value="0" :callback="function(data){ change_data(data); }" />

      <small class="hit-html-small" ><a target="_blank" class="hit-html-a"  v-bind:href="get_href()">{{ $t("message.goTo", {name: '"'+$t("message.terms")+'"'}) }}</a></small>

    </div>
  </div>

</template>

<script>

export default{

  props: { callback: Function },

  data: function () {
    return {

    }
  },

  methods: {

    get_href: function () {
      if(typeof this.$router === 'undefined') {
        return this.$get_url().www_url + '/v1/de/terms.html'
      }
      var link = this.$get_url().www_url + this.$router.resolve({ name: 'terms',
        params: {
          lang: this.$route.params.lang
        }
      }).href

      return link
    },

    change_data: function (data) {
      if (typeof this.callback === 'function') { this.callback(data) }
    },

    get_toggle: function () {
      var r = {}
      r[ '<i class="hit-glyphicon hit-glyphicon-ok" ></i> ' + this.$t('message.yes') ] = 1
      r[ '<i class="hit-glyphicon hit-glyphicon-remove" ></i> ' + this.$t('message.no') ] = 0

      return r
    }
  }

}

</script>
